<template>  
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <v-card>
          <v-card-title>
            Dados do atendente:
          </v-card-title>
          <v-card-text>
            <v-row>              
              <v-col
              >
                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  type="email"
                  :counter="250"
                  label="Email de acesso"
                  placeholder="Email de acesso do atendente ao EasyTools"
                  required
                >
                </v-text-field>
              </v-col>
            </v-row>
            <v-btn
              :disabled="!valid"
              color="success"
              type="submit"
            >
              {{ this.selectedAttendant ? 'Atualizar' : 'Cadastrar'}}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-card>
          <v-card-title>
            Atende para os produtos:
          </v-card-title>
          <v-card-text>
            <v-treeview
              selectable
              v-model="stores"
              selected-color="red"
              :items="$store.state.stores.map(s => {return {
                id: s.id,
                name: s.name,
                children: s.contact_statuses.map(cs => { return {
                  id: `${s.id},${cs.id}`,
                  name: cs.status
                }})
              }})"
            ></v-treeview>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-form>  
</template>

<script>
  export default {
    name: 'Form',
    props: {
      selectedAttendant: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    created() {      
      this.$store.dispatch('fetchStores');
      setTimeout(() => this.setStores(), 500);
    },
    methods: {
      reset () {
        this.$refs.form.reset();
      },
      submit() {
        if (this.$refs.form.validate()) {
          const data = {
            email: this.email,
            user_role: this.user_role,
            /*google_oauth: this.google_oauth,            */
            stores: this.formated_stores
          };

          if (this.selectedAttendant) {
            data.id = this.selectedAttendant.id;
          }

          this.$store.dispatch('createAttendant', {data});
          this.$emit('update');
          this.$emit('close');
        }
      },
      setStores() {
        let attendingStores = [];
      
        if(this.selectedAttendant 
          && this.selectedAttendant.attending_stores.length
          && !(this.stores.length)  
        ){
          const attendingStatus = this.selectedAttendant.attending_status;

          this.selectedAttendant.attending_stores.map((store) => {
            if(attendingStatus[store.id].length == 6) {
              attendingStores.push(store.id)
            }

            else{
              attendingStatus[store.id].map((status) => {
                attendingStores.push(`${store.id},${status.id}`)
              });
            }
          });

          this.stores = attendingStores;
        }
      }
    },    
    data () {
      return {
        valid: false,
        testeId: 0,
        stores: [],
        formated_stores: {},        
        user_role: this.selectedAttendant ? this.selectedAttendant.user_role : '',
        name: this.selectedAttendant ? this.selectedAttendant.name : '',
        email: this.selectedAttendant ? this.selectedAttendant.email : '',
        google_oauth: this.selectedAttendant ? this.selectedAttendant.google_oauth : '',
        nameRules: [
          v => !!v || 'Insira o nome do atendente',
          v => v && v.length <= 250 || 'O nome do atendente deve ter no máximo 250 caracteres',
        ],
        utmRules: [
          v => !!v || 'Insira o identificador do atendente',
          v => v && v.length <= 250 || 'O identificador do atendente deve ter no máximo 250 caracteres',
        ],
        emailRules: [
          v => /.+@.+/.test(v) || 'Endereço de Email inválido',
          v => !!v || 'Insira o email do atendente',
        ],
        teste: []
      }
    },
    watch: {
      stores(o,n) {
        const stores = {};           
        o.forEach(s => {
          if (typeof s === 'string') {
            const [store_id, status_id] = s.split(",");
            if (!stores[parseInt(store_id)]) {
              stores[parseInt(store_id)] = [parseInt(status_id)];
            } else {
              stores[parseInt(store_id)].push(parseInt(status_id));
            }            
          }
        });
        this.formated_stores = stores;
      }
    }   
  }
</script>

<style lang="css" scoped>
</style>